const config = {
  apiUrl: process.env.REACT_APP_OCR_API_URL ?? 'http://localhost:3000',
}

export default config
